import React, { useState, useEffect } from "react"
import _ from "lodash"
import { useFormikContext, Field } from "formik"

import { Dropdown } from "primereact/dropdown"

import styles from "../../../../../../styles/Form.module.css"
import actionActivityDef from "./resources/actionActivity.json"

export default function DynamicActionActivity(props) {
  const [actionActivityOptions, setActionActivity] = useState([])

  const formik = useFormikContext()
  const currentNestedMFValues = formik.values[props.mfFieldName][props.mfIndex]

  const { goal } = currentNestedMFValues

  const {
    field,
    index,
    mfFieldName,
    mfIndex,
    nestedMfFieldName,
    nestedMfIndex,
  } = props

  const fieldSlug = `${mfFieldName}.${mfIndex}.${nestedMfFieldName}.${nestedMfIndex}.${field.field_name}`

  useEffect(() => {
    const goalActionActivity = _.find(actionActivityDef, { goal })
    if (goalActionActivity) setActionActivity(goalActionActivity.options)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [goal])

  // const isRequired = field.field_required.required[0] === "true"
  const isRequired = true

  return (
    <div
      className={styles.field}
      style={{
        order: index,
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <Field name={fieldSlug}>
        {({ field: formikField, meta }) => (
          <>
            <Dropdown
              placeholder="Please select"
              id={field.field_name}
              name={formikField.name}
              value={formikField.value}
              onChange={formikField.onChange}
              options={actionActivityOptions}
            />
            {meta.error && (
              <div className={styles.errFieldMsg}>{meta.error}</div>
            )}
          </>
        )}
      </Field>
    </div>
  )
}
